module.exports = __webpack_public_path__ + "static/media/Coaching.742abde1.jpg";